import React, { useState } from 'react';
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

import './MaintenanceBanner.scss';
import CrossIcon from '../../../assets/icons/cross-circle.svg';
import PostIcon from '../../../assets/icons/accept-icon-black.svg';

const bannerColors = {
  upcoming: { backgroundColor: '#FFD790' },
  post: { backgroundColor: '#EFCCFF' },
};
const MaintenanceBanner = ({ banner }: any) => {
  const [visible, setVisible] = useState(true);
  const [visibleDialog, setVisibleDialog] = useState(false);
  const openDialog = () => setVisibleDialog(true);
  const closeDialog = () => setVisibleDialog(false);

  const getBannerIcon = (bannerType: any) => {
    if (bannerType === 'post') return <img src={PostIcon} alt="post icon" width={16} height={15} style={{ marginRight: '6px' }} />;
    if (bannerType === 'upcoming') return 'pi pi-info-circle';
    return 'pi pi-check-circle';
  };
  const footer = (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Button
        label="Close"
        onClick={closeDialog}
        outlined
        style={{
          fontWeight: '600',
          borderRadius: '8px',
          border: '0px solid black',
          backgroundColor: 'white',
          color: 'black'
          // padding: '0.5rem 1.2rem',
        }}
      />
    </div>
  );
  if (!visible) return null;
  if (!banner?.banner_type) return null;
  return (
    <div className="flex justify-between items-center px-4 py-2 border-b banner" style={{ ...bannerColors[banner.banner_type] }}>
      <div className="flex-1">
        <Message
          severity="info"
          text={(
            <>
              <strong>
                Version
                {' '}
                {banner.version}
                {' '}
                -
              </strong>
              {' '}
              {banner.message}
              {' '}
              {banner.maintenance_scheduled_time}
              {banner.banner_type === 'post' && banner.release_notes !== '' && (
                <span className="know-more" onClick={openDialog}>Know More</span>
              )}
              {' '}
            </>
          )}
          className="bg-transparent text-gray-800 border-none shadow-none p-0"
          icon={getBannerIcon(banner.banner_type)}
        />
      </div>

      <Button
        style={{ height: '27px', width: '4px', alignSelf: 'flex-start', border: 'none' }}
        icon={() => <img src={CrossIcon} alt="cross" />}
        // icon="pi pi-times"
        className="p-button-text p-button-sm text-gray-600 hover:text-gray-800 close-banner-btn"
        onClick={() => setVisible(false)}
        aria-label="Close"
      />
      <Dialog
        header={(
          <strong>
            Release
            &nbsp;
            {banner.version}
          </strong>
        )}
        visible={visibleDialog}
        style={{ width: '50vw' }}
        onHide={closeDialog}
        footer={footer}
        closable={false}
      >
        <p className="m-0" style={{ whiteSpace: 'pre-line' }}>
          {banner.release_notes}
        </p>
      </Dialog>
    </div>
  );
};
export default MaintenanceBanner;
